import React, { useEffect, useRef, useState } from "react"
import {
  message,
  Modal,
  Spin,
} from "antd"
import axios from "axios"

export const PreviewImgOrPdf = (props: {
  token: string
  AXIOS_IP: string
  file: any
  onClose: () => void
}) => {
  const [baseUrl, setBaseUrl] = useState("")

  const [isModalVisible, setIsModalVisible] = useState(false) //预览

  const [baseType, setBaseType] = useState(true)

  const [loading, setLoading] = useState(false)

  const blobUrlRef = useRef("")

  const getBase64Url = (v: any, type = false) => {
    setLoading(true)
    axios({
      url: `${props.AXIOS_IP}/infra/file/downloadFile/${v.fileConfigId}/${v.filePath}`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": props.token,
      },
      withCredentials: false,
      method: "GET",
    }).then((res: any) => {
      const base64 = res.data
      const byteChars = atob(base64)
      const byteArr = new Uint8Array(byteChars.length)
      for (let i = 0; i < byteChars.length; i++) {
        byteArr[i] = byteChars.charCodeAt(i)
      }
      const blob = new Blob([byteArr], { type: v.fileType || 'application/pdf' })
      const url = URL.createObjectURL(blob)
      if (type) {
        const link = document.createElement("a")
        link.href = url
        link.download = "参考模板.pdf"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      } else {
        setBaseType(v.fileType?.includes("pdf") ? true : false)
        if (blobUrlRef.current) {
          URL.revokeObjectURL(blobUrlRef.current)
        }
        blobUrlRef.current = url
        setBaseUrl(url)
        setIsModalVisible(true)
      }
    }).catch(() => {
      message.error("文件加载失败")
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    if (props.file) {
      getBase64Url(props.file)
    }
  }, [props.file])

  useEffect(() => {
    return () => {
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current)
      }
    }
  }, [])

  return (
    <>
      <Modal
        title={"预览"}
        visible={isModalVisible}
        footer={null}
        width={"80%"}
        zIndex={1100}
        onCancel={() => {
          setIsModalVisible(false)
          props.onClose()
        }}
      >
        <Spin spinning={loading} tip="文件加载中...">
          <div style={{ height: "650px" }}>
            {baseType ? (
              <iframe
                title="预览"
                style={{ width: "100%", height: "100%" }}
                src={baseUrl}
              />
            ) : (
              <img
                // v-else
                src={baseUrl}
                alt="预览图片"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            )}
          </div>
        </Spin>
      </Modal>
    </>
  )
}
